import SuperRepository from '../superRepository'

export default new (class EventsRepository extends SuperRepository {
  baseUri() {
    return 'event'
  }
})()
